export const EventListenerUtils = {
  addBeforeUnloadEvent(event: () => any) {
    window.addEventListener('beforeunload', event);
  },
  removeBeforeUnloadEvent(event: () => any) {
    window.removeEventListener('beforeunload', event);
  },
  addPageHideEvent(event: (ev: PageTransitionEvent) => void) {
    window.addEventListener('pagehide', event);
  },
  removePageHideEvent(event: (ev: PageTransitionEvent) => void) {
    window.removeEventListener('pagehide', event);
  },
  handlePageDiscard(ev: PageTransitionEvent, callback: () => void) {
    if (!ev.persisted) {
      callback();
    }
  }
};